import React from "react";
import { Form, Label } from "semantic-ui-react";
import SemanticDatepicker from "react-semantic-ui-datepickers";

const DateInput = ({ input, width, placeholder, meta: { touched, error } }) => {
  return (
    <Form.Field error={touched && !!error} width={width}>
      <SemanticDatepicker
        value={input.value}
        placeholder={placeholder}
        onChange={(e, data) => input.onChange(data.value)}
        onBlur={(e, data) => input.onBlur(data)}
        locale="es-ES"
        type="basic"
        clearOnSameDateClick={false}
        pointing="right"
        format="DD/MM/YYYY"
      />
      {touched && error && (
        <Label basic color="red" pointing>
          {error}
        </Label>
      )}
    </Form.Field>
  );
};

export default DateInput;
